import { useDatasets } from "src/datasets/api/queries";
import { useAuthoringContext } from "src/router/routerContextHooks";
import { useSimulationRun } from "src/simulations/useSimulationRun";

export const useSimulationDatasetBySimulationId = (simulationId: string) => {
  const { flow, version, workspace } = useAuthoringContext();
  const { data: simulationRun } = useSimulationRun(
    flow.id,
    version.id,
    simulationId,
  );
  const simulationSourceId = simulationRun?.source_id;

  const { data: datasets } = useDatasets({
    flowId: flow.id,
    baseUrl: workspace.base_url,
  });

  return datasets?.find(
    (dataset) =>
      simulationSourceId &&
      dataset.simulation_dataset_detail?.job_source_id === simulationSourceId,
  );
};
